var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_table_wrap"},[_vm._v(" 멤버 업데이트 레이아웃 "),_c('div',[_c('button',{staticClass:"mr30",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("목록")]),_c('button',{staticClass:"mr30",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("저장")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }